import { createUpdateCollectionSyncSlice } from '@sonar-software/xuder';
import { notificationsGetSlice } from '../@async/get';
import { NotificationsName } from '../name';

export const updateNotifications = createUpdateCollectionSyncSlice({
	hasRequest: false,
	name: NotificationsName,
	state: notificationsGetSlice.asyncState,
	update: () => (notification) => ({
		...notification,
		isRead: true
	})
});
